import moment from 'moment';

export default class Calender {
    constructor() {
        this.dateObject = moment().clone();
    }

    weekDayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']


    init(parent) {
        this.parent = parent
        this.today = this.getToday()
        this.activeDay = this.today
        this.setActiveRange(this.today, this.today)
        this.forceUpdate()
    }


    forceUpdate() {
        if (this.parent && this.parent.forceUpdate) {
            setTimeout(() => {
                this.parent.forceUpdate()
            }, 10)
        }
    }

    setActiveDay = (day) => {
        this.activeDay = day
        this.forceUpdate()
    }

    setActiveRange = (start, end) => {
        this.activeRange = { start, end }
        // this.forceUpdate()
    }


    toMoment() {
        return this.dateObject.clone();
    }

    goToToday() {
        this.dateObject = moment().clone();
        this.today = this.getToday()
        this.activeDay = this.today
        this.forceUpdate()

    }


    getToday() {
        let now = moment()
        let today = { moment: now, year: now.format('YYYY'), month: now.format('MM'), day: now.format('D'), dayOfWeek: Number(now.format('d')), startOfDay: now.startOf('day').valueOf(), endOfDay: now.endOf('day').valueOf() }
        today.key = today.year + '-' + today.month + '-' + today.day
        return today
    }


    getDayInfo(dayMoment) {

        let day = { moment: dayMoment, year: dayMoment.format('YYYY'), month: dayMoment.format('MM'), day: dayMoment.format('D'), dayOfWeek: Number(dayMoment.format('d')), startOfDay: dayMoment.startOf('day').valueOf(), endOfDay: dayMoment.endOf('day').valueOf() }
        day.key = day.year + '-' + day.month + '-' + day.day
        return day
    }


    getWeek() {
        let dateObject = this.dateObject.clone().startOf('week');
        if (dateObject.format('D') == 1) {
            let startOfDay = dateObject.startOf('month').day();
            dateObject.subtract(startOfDay - 1, 'days')
        }

        let week = [];
        let date = [];
        for (let i = 0; i < 7; i++) {
            let dObject = { moment: dateObject.clone(), day: dateObject.format('D'), year: dateObject.format('YYYY'), month: dateObject.format('MM'), dayOfWeek: Number(dateObject.format('d')), startOfDay: dateObject.startOf('day').valueOf(), endOfDay: dateObject.endOf('day').valueOf() }
            dObject.key = dObject.year + '-' + dObject.month + '-' + dObject.day
            week.push(dObject)
            dateObject.add(1, 'day')
        }

        this.setActiveRange(week[0], week[6])

        // this.activeRange = { start: this.today, end: this.today }


        // console.log(week)
        return week;
    }
    getMonth() {
        let dateObject = this.dateObject.clone().startOf('month');
        let startDay = dateObject.startOf('month').day();
        // dateObject.subtract(startOfDay - 1, 'days');
        let weeks = [];
        let days = []

        // console.log(startDay)

        for (let i = 0; i < startDay - 1; i++) {
            days.push(null)
        }

        let firstDay

        for (let i = 0; i < moment(dateObject).daysInMonth(); i++) {



            let temp = moment(dateObject).add(i, 'day')
            let day = { moment: temp, day: temp.format('D'), year: temp.format('YYYY'), month: temp.format('MM'), dayOfWeek: Number(temp.format('d')), startOfDay: temp.startOf('day').valueOf(), endOfDay: temp.endOf('day').valueOf() }
            day.key = day.year + '-' + day.month + '-' + day.day

            if (i == 0) {
                firstDay = day
            }

            days.push(day)
        }

        let lastDay = days[days.length - 1]

        let count = 0


        let week = []

        for (let i = 0; i < days.length; i++) {

            count++
            week.push(days[i])
            if (count == 7 || i == days.length - 1) {
                weeks.push(week)
                count = 0
                week = []
            }
        }

        // for (let i = 0; i < 5; i++) {
        //     let week = [];
        //     for (let j = 0; j < 7; j++) {

        //         let dObject = { day: dateObject.format('D'), year: dateObject.format('YYYY'), month: dateObject.format('MM'), dayOfWeek: Number(dateObject.format('d')), startOfDay: dateObject.startOf('day').valueOf(), endOfDay: dateObject.endOf('day').valueOf() }
        //         dObject.key = dObject.year + '-' + dObject.month + '-' + dObject.day


        //         week.push(dObject)
        //         dateObject.add(1, 'day')
        //     }
        //     weeks.push(week)
        // }


        let lastWeekLenght = weeks[weeks.length - 1].length
        if (lastWeekLenght < 7) {
            for (let i = 0; i < 7 - lastWeekLenght; i++) {

                weeks[weeks.length - 1].push(null)
            }
        }


        this.setActiveRange(firstDay, lastDay)



        return weeks;

    }



    goToNext(type) {
        if (type == 'week') {
            if (this.dateObject.format('D') == 1) {
                let startOfDay = this.dateObject.clone().startOf('month').day();
                this.dateObject.subtract(startOfDay - 1, 'days')
            }
        }
        this.dateObject.add(1, type)

        if (type == 'day') {
            this.setActiveRange(this.dateObject, this.dateObject)
        }

        this.activeDay = this.getDayInfo(this.dateObject)


        this.forceUpdate()

    }
    goToPrev(type) {
        if (type == 'week') {
            if (this.dateObject.format('D') == 1) {
                let startOfDay = this.dateObject.clone().startOf('month').day();
                this.dateObject.subtract(startOfDay - 1, 'days')
            }
        }

        this.dateObject.subtract(1, type)

        if (type == 'day') {
            this.setActiveRange(this.dateObject, this.dateObject)

        }

        this.activeDay = this.getDayInfo(this.dateObject)


        this.forceUpdate()

    }
    setMonth(monthNumber) {

        let diff = monthNumber - this.dateObject.format('MM')
        if (diff < 0) {
            this.dateObject.subtract(-diff, 'month');
        } else {
            this.dateObject.add(diff, 'month')
        }

        this.forceUpdate()


    }
    setYear(year) {
        let diff = year - this.dateObject.format('Y')
        if (diff < 0) {
            this.dateObject.subtract(-diff, 'year');
        } else {
            this.dateObject.add(diff, 'year')
        }
        this.forceUpdate()

    }

}





